<template>
    <div class="PinsPartsFootprintComponent DataTables">


        <span v-show="isData">

            <p>{{ lang.infotext_4 }}: <b>{{ footprintListSelected.length == 0 ? "" : footprintListSelected }}</b></p>
            <span class="footprint-label"></span>
            <div :id="id"></div>
        </span>
        <LoaderComponent v-if="!isData"></LoaderComponent>
        <br>
    </div>
</template>
<script>


import LoaderComponent from "@/components/shared/LoaderComponent";
import { mapGetters } from 'vuex'
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from '@/Tools/Tools'
import LibraryTypes from '@/constants/LibraryTypes'

export default {
    name: 'PinsPartsFootprintComponent',
    props: {
        lang: Object,
        parent: String

    },
    components: {
        LoaderComponent

    },
    data() {
        return {
            name: 'PinsPartsFootprintComponent',
            
            mainTable: "",
            id: "PinsPartsFootprintComponent" + this._uid,
            
            columns: [],
            
            colsAssign: [],
            elements: [],
            isData: false,
            //elementId: "",

            
            footprints: [],
            footprintItems: [],
            footprintListSelected: "",
        }
    },
    computed: {
        ...mapGetters([
            'selectedRevisionRow',
            'appConf'
        ]),
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        isNoEmptyLibraries() {
            return this.symbolListSelected.length == 0 && this.symbolHDLListSelected.length == 0 && this.footprintListSelected.length == 0;
        },
        elementId() {
            if (this.$route.path == "/PartManager/PartTable") {
                if (this.$store.getters.selectedRows[0] != undefined) {
                   
                    return this.$store.getters.selectedRows[0].col___revisionId.partId;
                    
                }
            }
            if (this.$route.path == "/LibrarytManager/LibraryTable") {
                if (this.$store.getters.selectedRows[0] != undefined) {
                                        
                    return this.$store.getters.selectedRows[0].col___revisionId.libraryId;
                    
                }
            }
            if (this.$route.path == "/PartManager/PartDetails") {
                
                return this.$route.query.id;
                
            }
            if (this.$route.path == "/LibraryManager/LibraryDetails") {
                
                return this.$route.query.id;
                
            }
        },
        revisionId() {

            if (this.parent == "bom") {
                return this.$store.getters.selectedPartBomRow.revisionId;
            }
            if (this.$route.path == "/PartManager/PartTable") {
                if (this.$store.getters.selectedRows[0] != undefined) {
                    
                    return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
                }
            }
            if (this.$route.path == "/PartManager/PartDetails" || this.$route.path == "/LibraryManager/LibraryDetails") {
              if (this.$store.getters.selectedRevisionRow.length == 0) {
                  return null;
              }
              if (this.$store.getters.selectedRevisionRow[0] == undefined) {

                  return this.$store.getters.selectedRevisionRow[0].revisionId;
              }
              return this.$store.getters.selectedRevisionRow[0].revisionId;
            }
            return "";




        },


        reloadedAfterActionComplex() {
            return this.$store.getters.reloadedAfterActionComplex;
        }

    },
    created() {

        this.createTables();


    },
    watch: {
        revisionId: {
            handler: function () {

                this.createTables();
            },
            deep: true


        },


        reloadedAfterActionComplex: {
            handler: function (newValue) {

                for (let el in newValue) {

                    if (newValue[el].name == this.name) {
                        if (newValue[el].status == true) {

                            this.createTables();

                            newValue[el].status = false;

                            this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                        }
                    }
                }
            },
            deep: true

        },
        
        
        footprintListSelected: function (newVal) {
            if (newVal != undefined) {
                if (newVal.length > 0) {

                    
                    this.buildTable();
                }
            }
        }
    },
    updated() {

    },
    mounted: function () {

    },
    methods: {
        analyzePins() {
            

            const data = {
                symbols: this.symbols,
                hdlsymbols: this.hdlsymbols,
                footprints: this.footprints
            }

            let func = function () {

            }

            const obj = {
                title: this.lang.modal_title_modal_PinAnalysis,
                text: "",
                type: "pinAnalysis",
                buttons: 1,
                buttonName: "Close",
                size: "xl",
                lang: this.lang.modal_PinAnalysis,
                funcNo: "",
                funcYes: "",
                funcCustom: func,
                data: data
            };
            this.$store.dispatch("showModalComponent", obj);
        },
        createTables() {
            this.isData = false;
            let vue = this;

            let prefix = this.$store.getters.sectionPrefix;
            if (this.parent == "bom") {
                prefix = "lm";
            }


            
            this.footprintListSelected = "";

            let obj = {

                partRevisionId: this.revisionId


            }


            this.$store.dispatch(prefix + "_getPins", obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {


                        vue.isData = true;

                        
                        vue.footprints = result.data[0].footprints;


                        vue.buildColumns();

                    } else {
                        vue.isData = false;
                    }


                })
        },
        buildColumns() {



            this.columns = [
                {
                    name: "Id",
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: this.lang.table_header_Number,
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: this.lang.table_header_Padstack,
                    alignInColumn: "left",
                    type: "taxt"
                },
                {
                    name: this.lang.table_header_Type,
                    alignInColumn: "left",
                    type: "text"
                },


            ]

            this.colsAssign = [
                { "data": "padstackRevisionId" },
                { "data": "pinNumber" },
                { "data": "padstackName" },
                { "data": "type" },


            ]


            

            this.cretesPinsTables();



        },
        cretesPinsTables() {

            


            //footprints
            this.footprintItems = [];
            this.footprintListOptions = [];
            if (this.footprints.length > 0) {
                
                for (let i = 0, lei = this.footprints.length; i < lei; i++) {
                    this.footprintListOptions.push(this.footprints[i].name)
                    let arr = [];

                    for (let j = 0, lej = this.footprints[i].pins.length; j < lej; j++) {

                        let obj = {
                            index: j,
                            pinNumber: this.footprints[i].pins[j].pinNumber,
                            padstackName: this.footprints[i].pins[j].padstackName,
                            type: this.footprints[i].pins[j].type,
                            padstackRevisionId: this.footprints[i].pins[j].padstackRevisionId,
                            padstackLibraryId: this.footprints[i].pins[j].padstackLibraryId
                        }
                        arr.push(obj);

                    }

                    this.footprintItems[this.footprints[i].name] = arr;

                }
                this.footprintListSelected = this.footprints[0].name;
            }
            
            //this.buildTable_symbols();
            //this.buildTable_hdlsymbols();
            this.buildTable();

        },
        
        buildTable() {
            
            var tableplace = document.getElementById(this.id);
            
            if (tableplace == null) {
                return;
            }
            
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("style", "width:100%");
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)
            
            var tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            var _vue = this;


            let columnDefs = [];
            var len = this.columns.length;
            for (var i = 0; i < len; i++) {

                var el = {};

                var classname = '_dt-body-' + this.columns[i].alignInColumn;

                el = {
                    targets: i,
                    className: classname,

                    render: function (data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }

                        


                        return data;
                    }


                }

                columnDefs.push(el);


                var th = document.createElement("th");
                tr.appendChild(th);
                //var p = document.createElement("p");
                //th.appendChild(p);
                var br = document.createElement("br");
                th.appendChild(br);
                var tx = document.createTextNode(this.columns[i].name)
                th.appendChild(tx);

            }

            let no = 1;

            
            var option = {};
            option.paging = true;
            option.info = true;
            option.dom = '<fr<t>ip>';
            option.data = this.footprintItems[this.footprintListSelected];
            option.myColumnFormats = this.columns;
            option.select = true;
            option.order = [[no, "asc"]];
            option.lengthMenu = [[8]];
            option.columns = this.colsAssign;

            option.columnDefs = columnDefs;
            option.initComplete = function () {


            }


            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();

            }

            var _vue = this;
            
            this.mainTable = $('#t_' + this.id).DataTable(option);

            this.mainTable.columns.adjust().draw();

            //hide first column in table


            this.mainTable.column(0).visible(false);


            let _mainTable = this.mainTable;


            $('#t_' + this.id + " tbody").on('dblclick', 'tr', function () {


                let rowData = _mainTable.rows(this._DT_RowIndex).data();

                _vue.goTo(rowData[0]);



            });


            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }
            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")
        },
        goTo(goalObj) {

            console.log("tu",goalObj)

            let id = goalObj.padstackLibraryId;

            let to = "/LibraryManager/LibraryDetails";

            let obj = {
                col___revisionId: {
                    revisionId: goalObj.padstackRevisionId,
                    libraryId: id,
                    value: {
                        display: goalObj.padstackRevisionId
                    }
                },
                col___revision: {
                    revisionId: goalObj.padstackRevisionId,
                    libraryId: id,
                    value: {
                        display: goalObj.revision
                    }
                },
                col___status: {
                    revisionId: goalObj.padstackRevisionId,
                    libraryId: id,
                    value: {
                        display: ""
                    }

                },
                col___name: {
                    revisionId: goalObj.padstackRevisionId,
                    libraryId: id,
                    value: {
                        display: ""
                    }

                },
                col___image: {
                    revisionId: goalObj.padstackRevisionId,
                    libraryId: id,
                    value: {
                        display: ""
                    }
                },
                col___libraryType: {
                    revisionId: goalObj.padstackRevisionId,
                    libraryId: id,
                    libraryType: LibraryTypes.PADSTACK,
                    value: {
                        display: LibraryTypes.PADSTACK
                    }
                },

            }






            const goToObj = {
                to: {
                    path: to,
                    revisionId: goalObj.padstackRevisionId,
                    id: goalObj.id
                },
                back: {
                    path: this.$route.path,
                    revisionId: this.revisionId,
                    id: this.elementId
                },
                bom: {

                }
            }
            console.log(goToObj)
            this.$store.dispatch("goTo", goToObj);



            this.$store.dispatch("deleteAllSelectedRows");
            this.$store.dispatch("setSelectedRows", [obj]);

            this.$store.dispatch("setOuterData", true);

            this.$store.dispatch("editPropertiesForm", false);




            const query = {
                from: this.$route.path,
                to: to,
                revisionId: goalObj.padstackRevisionId,
                id: id,
                sourceId: this.elementId,
                sourceRevisionId: this.revisionId,
                end: false
            }
console.log(query)
            this.$router.push({ path: to, query: query });
        },

    }
}
</script>


<style lang="scss">
.PinsPartsFootprintComponent {
    width: 100%;

    .dataTable {
        width: 100%;
    }

    table {
        font-size: 0.75rem;
        padding: 0px !important;

    }

    table th {
        padding: 2px !important;

    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    table.dataTable thead th p {
        margin-right: 20px;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        float: left;
        width: 210px;
    }

    .searcher {
        float: left;
    }

    .dt-buttons {

        font-size: 0.7rem;
        margin-left: 210px;

    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
        padding: 0.1rem 0.1rem;
        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    .btn {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 3px;
        padding-right: 3px;

        font-size: 0.7rem;

    }

    .btn-group {
        display: block;
        padding-top: 2px;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    .custom-select-sm {
        height: calc(1em + 0.5rem + 2px);
        padding-top: 0.0rem;
        font-size: 0.75rem;
    }

    .primitive-label {
        float: right;
    }

    .select-symbol {
        margin-bottom: 5px;
        width: 50%;
        float: right;
    }

    .select-symbolhdl {
        margin-bottom: 5px;
        float: right;
        width: 50%;
    }

    .primitive-select-group {
        float: right;
        width: 50%;
    }

    .primitive-select {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/PinsPartsFootprintComponent.vue